export default "__VITE_ASSET__FpuUVr2z__"